export const SUPPORTED_LOCALES = ['en', 'es', 'ka', 'mn', 'pl', 'pt-BR', 'ru', 'uk'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
